export default __webpack_public_path__ + "static/media/RecycleBinLow.cfeeb600.svg";